import React from 'react';
import { useSelector } from 'react-redux';
import { Table, Popconfirm, Flex, Button, Typography } from 'antd';

import { TableCol } from './getTableCol';

import { planStruct } from './struct';
import { getRandomId } from '../../../../../../utilities/randomId';

const { Title } = Typography

export const Plan = ({ planing, handlePlaning, status }) => {
  const _static = useSelector((state) => state.static);
  const { staticData } = _static;
  const { events, evaluation_status: evaluationStatus } = staticData;

  const handleAdd = () => {
    const newPlaning = {
      key: getRandomId(),
      event: events[0].id,
      detail: '',
      attachment: []
    };
    handlePlaning([...planing, newPlaning]);
  };

  const handleSave = (row) => {
    const currentCourses = [...planing];
    const index = currentCourses.findIndex((item) => row.key === item.key);
    const item = currentCourses[index];

    currentCourses.splice(index, 1, {
      ...item,
      ...row
    });
    handlePlaning(currentCourses);
  };

  const handleDelete = (key) => {
    const newData = planing.filter((item) => item.key !== key);
    handlePlaning(newData);
  };

  const columns = [
    ...TableCol(handleSave, status),
    {
      title: 'Action',
      dataIndex: 'operation',
      render: (_, record) => (
        <Popconfirm
          title="Sure to delete?"
          onConfirm={() => handleDelete(record.key)}
          disabled={status === 1 || status === 2 || status === 3}
        >
          <a>Delete</a>
        </Popconfirm>
      )
    }
  ];

  return (
    <>
      <Flex justify='flex-end'>
        {
          evaluationStatus?.filter((e) => e.value === status)?.length > 0 &&
          <Title level={5}>
            Status~
            {evaluationStatus?.filter((e) => e.value === status)?.[0]?.label}
          </Title>
        }
      </Flex>
      <Table {...planStruct.table} columns={columns} dataSource={planing} />
      <br />

      <Flex {...planStruct.actionSection}>
        <Button className="glow-btn" disabled={status === 1 || status === 2 || status === 3} onClick={handleAdd}>Add New Item</Button>{' '}
      </Flex>

      <Typography.Text type="secondary" style={{ display: 'block', marginTop: 8, fontSize: 12, color: '#e92a2a' }}>
        *Attachments Mandatory
      </Typography.Text>
    </>
  );
};
